import { FormModalControlled, type FormModalControlledProps } from "@common/controls/Modal/Modals/Form/component";
import React from "react";
import OtpContext, { OtpContextProvider } from "../Otp/context";
import { type OtpApi, type WithOtp } from "../Otp/types";

type Props<T> = Omit<FormModalControlledProps<T>, "submit"> & {
  getOtpApi: (data: T) => OtpApi;
  submit: (data: T & WithOtp) => Promise<boolean>;
};
const FormModalOtpControlledInner = <T extends object>({ getOtpApi, submit, ...props }: Props<T>) => {
  const otpContext = React.useContext(OtpContext);

  const _submit = React.useCallback(
    async (data: T): Promise<void> => {
      const otpApi = getOtpApi(data);
      const isValid = await otpContext.start({
        ...otpApi,
        validateCode: (otp) => submit({ ...data, otp })
      });
      if (isValid && props.onClose) props.onClose();
    },
    [getOtpApi, otpContext.start, submit, props.onClose]
  );

  return <FormModalControlled {...props} submit={_submit} />;
};

const FormModalOtpControlled = <T extends object>(props: Props<T>) => (
  <OtpContextProvider>
    <FormModalOtpControlledInner {...props} />
  </OtpContextProvider>
);
export default FormModalOtpControlled;
